import React from "react"

function Header() {
    return (
        <header>
            <div id="logo">
                <img src="https://emeryyu.github.io/resources/Images/logo.png"></img>
            </div>
        </header>

    )
}

export default Header;